import * as actionTypes from '../../../constants/actionTypes'

const initState = {
    loginStatus: false,
    mobile: '',
}

const configReducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.LOGIN:
            return {
                ...state,
                loginStatus: true,
                mobile: action.payload
            }
        case actionTypes.LOGOUT:
            return {
                ...state,
                loginStatus: false,
                mobile: ''
            }
        default:
            return state
    }
}

export default configReducer
